interface FieldValue {
  column?: string;
  meta?: {
    path: string[];
  };
}

interface SectionValue {
  [key: string]: FieldValue | { [key: string]: FieldValue };
}

interface Config {
  [sectionKey: string]: SectionValue;
}

function createNestedPath(obj: any, path: string[], value: string): void {
  let current = obj;

  path.slice(0, -1).forEach((key) => {
    if (!current[key]) {
      current[key] = {};
    }
    current = current[key];
  });

  const lastKey = path[path.length - 1];
  current[lastKey] = value;
}

export default function normalizeConfig(config: Config): any {
  if (!config) return config;
  const result: any = {};

  Object.entries(config).forEach(([sectionKey, sectionValue]) => {
    result[sectionKey] = {};

    Object.entries(sectionValue).forEach(([fieldKey, fieldValue]) => {
      const typedFieldValue = fieldValue as
        FieldValue | { [key: string]: FieldValue };

      if ('column' in typedFieldValue && typedFieldValue.column !== undefined) {
        const fieldValueTyped = typedFieldValue as FieldValue;
        if (fieldValueTyped.meta?.path && fieldValueTyped.column) {
          createNestedPath(
            result[sectionKey],
            fieldValueTyped.meta.path,
            fieldValueTyped.column,
          );
        } else if (fieldValueTyped.column) {
          result[sectionKey][fieldKey] = fieldValueTyped.column;
        }
      } else {
        Object.entries(
          typedFieldValue as { [key: string]: FieldValue },
        ).forEach(([nestedKey, nestedValue]) => {
          if (nestedValue.meta?.path && nestedValue.column) {
            createNestedPath(
              result[sectionKey],
              nestedValue.meta.path,
              nestedValue.column,
            );
          } else if (nestedValue.column !== undefined) {
            if (!result[sectionKey][fieldKey]) {
              result[sectionKey][fieldKey] = {};
            }
            result[sectionKey][fieldKey][nestedKey] = nestedValue.column;
          }
        });
      }
    });
  });

  return result;
}
